import Container from "../Container";
import classes from "./index.module.scss";
import rulerWebp from "../images/ruler.webp";
import rulerPng from "../images/ruler.png";
import bottleWebp from "../images/bottle.webp";
import bottlePng from "../images/bottle.png";

export default function Banner() {
  return (
    <section className={classes.section}>
      <Container>
        <div className={classes.body}>
          <div className={classes.image}>
            <picture>
              <source srcSet={bottleWebp} type="image/webp" />
              <source srcSet={bottlePng} type="image/png" />
              <img src={bottlePng} alt="Shapely" width={179} height={187} />
            </picture>
          </div>
          <div className={classes.image}>
            <picture>
              <source srcSet={bottleWebp} type="image/webp" />
              <source srcSet={bottlePng} type="image/png" />
              <img src={bottlePng} alt="Shapely" width={179} height={187} />
            </picture>
          </div>
          <div className={classes.image}>
            <picture>
              <source srcSet={bottleWebp} type="image/webp" />
              <source srcSet={bottlePng} type="image/png" />
              <img src={bottlePng} alt="Shapely" width={76} height={140} />
            </picture>
          </div>
          <div className={classes.image}>
            <picture>
              <source srcSet={rulerWebp} type="image/webp" />
              <source srcSet={rulerPng} type="image/png" />
              <img src={rulerPng} alt="Shapely" width={92} height={84} />
            </picture>
          </div>
          <div className={classes.image}>
            <picture>
              <source srcSet={rulerWebp} type="image/webp" />
              <source srcSet={rulerPng} type="image/png" />
              <img src={rulerPng} alt="Shapely" width={183} height={183} />
            </picture>
          </div>
          <p className={classes.text}>
            Impress yourself.
            <br />
            Progress faster, achieve more.
          </p>
        </div>
      </Container>
    </section>
  );
}
